import ApplicationEntity from '../commonUtil/appEntity';
import { ValidationErrorCode } from '../commonUtil/constants';
import MicroAppPagesCollection from '../commonUtil/microappView';
import ContentType from '../model/contentType';

export const buildManifestModel = (response, state) => {
    const { ContentManifests, Code, Message } = response;
    const { contentCovers, selectedContent } = state;
    if (Code === ValidationErrorCode.LIVESEND_MANIFEST_OK) {
        const manifests = ContentManifests || [];
        let selectedManifest = {};
        if (selectedContent && selectedContent.id) {
            selectedManifest = { ...manifests.find(c => c.Id === selectedContent.id).OriginalManifests };
            ApplicationEntity.getInstance().selectedContentId = selectedContent.id;
            if (selectedContent.format === ContentType.MICROAPP) {
                MicroAppPagesCollection.getInstance().selectedContentVersionId = selectedContent.versionId;
                MicroAppPagesCollection.getInstance().isMicroApp = true;
            } else {
                MicroAppPagesCollection.getInstance().isMicroApp = false;
            }
        }

        const newContentCovers = contentCovers.map((cc) => {
            const contentManifest = manifests.find(mf => mf.Id === cc.id);
            return {
                id: cc.id,
                cover: (contentManifest && contentManifest.OriginalManifests && contentManifest.OriginalManifests.CoverImageUrl)
                    || cc.cover
            };
        });

        const manifestData = {
            manifests,
            selectedManifest,
            errorCode: Code,
            errorMessage: Message
        };

        return { ...manifestData, contentCovers: newContentCovers };
    }

    const manifestData = {
        errorCode: Code,
        errorMessage: Message
    };

    return { ...manifestData };
};
